import React, { useContext, useState, useLayoutEffect} from "react";
import WebServiceContext from "../WebService/ServiceContext";


const PosterLoader = (props:AttachmentPostersProps) => {
    
    const ws = useContext(WebServiceContext)
    const [pic, setPic]=useState<string|undefined|false>(undefined) 
        
    useLayoutEffect(()=>{
        ws.WebService.asyncGetCardPoster(props.FPath).then((res: any) => {
            if(res =="取得圖片失敗"){
                setPic(false)
            }else{
                setPic(res)
            }
            
        })
        return
    },[props])
    /*
    const imgStyle:React.CSSProperties=
        props.type == "photo"?
        {width:"100%", height:"100%", maxHeight:800, objectFit:"contain"}:
        props.type == "icon" &&
        {}
    */
    return (
        <>
            {
                pic == false ?
                "圖片取得失敗":
                <img style={props.imgStyle} src={pic}/>
            }
        </>
    )
}

export default PosterLoader
